import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Pagination} from 'kpc';

var _$tmp0 = {
    'noBorder': true,
    'total': 200,
    'size': 'large'
};
var _$tmp1 = {
    'noBorder': true,
    'total': 200
};
var _$tmp2 = {
    'noBorder': true,
    'total': 200,
    'size': 'small'
};
var _$tmp3 = {
    'noBorder': true,
    'total': 200,
    'size': 'mini'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Pagination, _$tmp0),
        _$cc(Pagination, _$tmp1),
        _$cc(Pagination, _$tmp2),
        _$cc(Pagination, _$tmp3)
    ], 4);
};